import { chunk } from 'lodash'

import FirestoreService from '../../firestoreService'

import { getConvertedData } from '../../../models/interface.helper'

import { IEventReviewPublish } from '../../../models/event-review-publish/event-review-publish.interface'
import { EventReviewPublishModel } from '../../../models/event-review-publish/event-review-publish.model'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getById = async (id: string) => {
  const publishedEventSnapShot = await FirestoreService.getItem(
    COLLECTIONS.EVENT_REVIEW_PUBLISH.NAME,
    id
  )
  return getConvertedData(
    EventReviewPublishModel.fromFirestoreDoc(publishedEventSnapShot).toObject()
  )
}
const getByIds = async (ids: string[]) => {
  const eventsReviewPublish: IEventReviewPublish[] = []

  if (ids?.[0]) {
    const chunks = chunk(ids, 30) // Firestore limits the 'in' clause to 30 items

    const queries = chunks.map((idsChunk) =>
      FirestoreService.getItemsUsingIds(COLLECTIONS.EVENT_REVIEW_PUBLISH.NAME, idsChunk)
    )

    const snapshotsArray = await Promise.all(queries)

    snapshotsArray.forEach((snapshots) => {
      snapshots.forEach((doc) => {
        const current = getConvertedData(EventReviewPublishModel.fromFirestoreDoc(doc).toObject())
        eventsReviewPublish.push(current)
      })
    })
  }

  return eventsReviewPublish
}

const EventReviewPublishService = {
  getById,
  getByIds,
}
export default EventReviewPublishService
